import React from 'react'
import { Text, View } from 'oio-react'
import { Link, Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import NoteLayoutContainer from '~/components/NoteLayoutContainer'
import TextCreate from './Text'

const NoteCreate = () => {
   const history = useHistory()
   const match = useRouteMatch()
   const { notebookSlug } = useParams()

   const redirectToNewNote = (response) => {
      // TODO: This route should not be hard-coded.
      // Temporary until we have more permanent routes figured out.
      // See PR #8
      history.push(`/notebook/${notebookSlug}/${response.data.experimentalCreateNote.id}`)
   }

   return (
      <Switch>
         <Route exact path={match.path}>
            <View>
               <Text size="6" weight="medium">Create</Text>
               <Link to={`${match.url}/text`}>
                  <View
                     display="inline-block"
                     width="200px"
                     height="200px"
                     backgroundColor="#eee"
                     margin="5px"
                     padding="10px">
                     Text Note
                  </View>
               </Link>
            </View>
         </Route>
         <Route
            exact
            path={`${match.path}/text`}
            render={props => (
               <NoteLayoutContainer>
                  <TextCreate onCreate={redirectToNewNote} />
               </NoteLayoutContainer>
            )}
         />
      </Switch>
   )
}

export default NoteCreate
